import React from "react";
import styled from "styled-components";
import bg from "../../images/compressedContact.jpg";
import TopBanner from "../../Sections/TopBanner/NewTopBanner";
import email_icon from "../../images/mail.png";
import phone_icon from "../../images/phone.png";
import location_icon from "../../images/location.png";
import { breakpoints } from "../../utils/breakpoints";

import newBanner from "../../images/social2025.jpeg";
import mobileBanner from "../../images/social2025.jpeg";

const StyledDiv = styled.div`
	overflow-x: hidden;
	background: #0A0B0D 0% 0% no-repeat padding-box;
	color: white;


	.content-container {
		padding: 100px 0;

		.contact-us-container {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			grid-gap: 20px;
			width: 100%;
			margin: auto;
			padding: 50px 0;
			text-align: left;
			font: normal normal normal 24px/40px Nexa-light;

			.info {
				display: grid;
				text-align: center
				color: #ffffff;
				padding: 10px 40px;
				border-radius: 8px;
			
				align-items: center;

				.icon{				
					margin: auto;
					align-items: center;
					display: flex;
				}

				.txt {
					padding-left: 0px;
					text-align: center;
					align-items: start;
					display: flex;
					margin: auto;

					.title {
						color: #44b2dd;
					}
				}
			}
		}
	}

	@media screen and ${breakpoints.device.laptopL} {
		.content-container {
			.contact-us-container {
				font: normal normal normal 20px/34px Nexa-light;
			}
		}
		
	}

	@media screen and ${breakpoints.device.mobileL} {
		.content-container {
			padding: 60px 0;
			.contact-us-container {
				padding: 30px 0;
				grid-template-columns: 1fr;
				width: 85%;
				

				.info {
					flex-direction: column;

					.txt {
						padding: 0;
						text-align: center;
					}
				}
			}
		}
	}
`;

const ContactUs = () => {
	return (
		<StyledDiv>
			<TopBanner
				bg={
					window.innerWidth < 750
						? mobileBanner
						: newBanner
				}

				title={
						<>
						Get In Touch
						</>
					}

				
				
			/>
			<div className="content-container">
				<div className="contact-us-container">
					<div className="info">
						<div className="icon">
							<img
								src={email_icon}
								alt=""
							/>
						</div>
						<div className="txt">
							
							<br />
							support@igeniusglobal.com
						</div>
					</div>
					<div className="info">
						<div className="icon">
							<img
								src={phone_icon}
								alt=""
							/>
						</div>
						<div className="txt">
							
							<br />
							1-801-939-3580
						</div>
					</div>
					<div className="info">
						<div className="icon">
							<img
								src={
									location_icon
								}
								alt=""
							/>
						</div>
						<div className="txt">
							
							<br />
							459 North 300 West
							
							Suite 15B
							
							Kaysville, UT 84037
						</div>
					</div>
					
				</div>
			</div>
		</StyledDiv>
	);
};

export default ContactUs;
